module.exports = __webpack_public_path__ + "img/amazonas.fc989103.jpg";